// store/slice/ReferralAuthSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ReferralUser {
  id: number;
  username: string;
  first_name: string;
  email: string;
  last_name: string;
  referral_partner: number;
  profile_picture_url?: string | null;
}

interface ReferralAuthState {
  user: ReferralUser | null;
  access_token: string | null;
  refresh_token: string | null;
}

// Hydrate from localStorage on app start
const initialState: ReferralAuthState = {
  user: JSON.parse(localStorage.getItem("referral_user") ?? "null"),
  access_token: localStorage.getItem("referral_access_token"),
  refresh_token: localStorage.getItem("referral_refresh_token"),
};

const referralAuthSlice = createSlice({
  name: "referralAuth",
  initialState,
  reducers: {
    setReferralAuth(state, action: PayloadAction<ReferralAuthState>) {
      state.user = action.payload.user;
      state.access_token = action.payload.access_token;
      state.refresh_token = action.payload.refresh_token;
    },
    clearReferralAuth(state) {
      state.user = null;
      state.access_token = null;
      state.refresh_token = null;
      localStorage.removeItem("referral_user");
      localStorage.removeItem("referral_access_token");
      localStorage.removeItem("referral_refresh_token");
    },
  },
});

export const { setReferralAuth, clearReferralAuth } = referralAuthSlice.actions;
export default referralAuthSlice.reducer;
